const commonKr = {
  kr: {
    // NOTE: temporary disable all kr translation because KR team won't have time to prepare all translation before launch
    //       therefore align both b2c/b2b to display English even if UI choose kr locale
    // common: {
    //   today: '오늘',
    //   reset: '재설정',
    //   // submit: '확인',
    //   search: '검색',
    //   stage: '단계',
    //   status: '현황',
    //   type: '분류',
    //   consultant: '소개인',
    //   search_rec_date: '신청서 수령일 (YYYY/MM/DD)',
    //   search_create_date: '작성일 (YYYY/MM/DD)',
    //   search_complete_date: '완성일 (YYYY/MM/DD)',
    //   included_team: '팀포함',
    //   documents: {
    //     no_file_found: 'No file found',
    //   },
    //   loading: '처리중...',
    //   sortable_column: '정렬',
    //   please_select: '선택해 주십시오',
    //   pdf_version: 'PDF 판',
    //   zip_version: 'ZIP',
    //   expand_tree: '확장',
    //   collapse_tree: '축소',
    // },
    // selection: {
    //   included_team: [['true', '네'], ['false', '아니오']],
    //   stage_type: [
    //     ['nb', '진행중'],
    //     ['all', '전부'],
    //     ['select', '사용자 지정'],
    //   ],
    //   stage_options: [
    //     ['', '-전부-'],
    //     [1, '단계1'],
    //     [2, '단계2'],
    //     [3, '단계3'],
    //     [4, '단계4'],
    //     [5, '단계5'],
    //     [6, '단계6'],
    //     [7, '단계7'],
    //     [8, '기타'],
    //   ],
    //   followup_type_options: [
    //     ['', '-전부-'],
    //     [6, 'Missing Premium'],
    //     [7, 'Renewal'],
    //   ],
    //   type_options: [
    //     ['', '-전부-'],
    //     ['D', '일임'],
    //     ['N', '비일임'],
    //     ['T', 'TR-Discretionary'],
    //   ],
    //   report_date_options: [ // report 3
    //     ['APPL', '신청서 수령일'],
    //     ['APPLSENT', '신청서 발송일'],
    //     ['POLICY', '발행일'],
    //   ],
    //   client_date_options: [  // report 2
    //     ['APPL', '신청서 수령일'],
    //     ['POLICY', '발행일'],
    //   ],
    //   report_type_options: [
    //     [1, '1. 계약실효 / 해약보고서'],
    //     [2, '2. 신규고객 보고서'],
    //     [3, '3. 신규 비즈니스 현황보고서'],
    //     [4, '4. 판매실적 보고서'],
    //     [5, '5. 전환가입 보고서'],
    //     [6, '6. 고객생일 보고서'],
    //     [7, '7. 미납적립금 보고서'],
    //     [8, '8. 신용카드만료 보고서'],
    //     [9, '9. 고객 포트폴리오 보고서'],
    //     [10, '10. 보험계약 요약보고서'],
    //     [11, '11. 보험계약 목록 상세 보고서'],
    //     [12, '12. 보험계약자 보고서'],
    //     [13, '13. Policy AB BV Report'],
    //     [14, '14. Personal AB BV Report'],
    //     [201, '201. Training History Report'],
    //   ],
    //   product_type_options: [
    //     ['', '-전부-'],
    //     ['IL', '투자형 보험'],
    //     ['IN', '보험플랜'],
    //   ],
    //   exclude_status_options: [
    //     ['CAN', '해지'],
    //     ['COF', '청약철회'],
    //     ['LAP', '계약실효'],
    //     ['SUR', '계약해약'],
    //     ['TOT', '전환해약'],
    //   ],
    //   lapsed_surrender_options: [
    //     ['', '-전부-'],
    //     ['LAP', '계약실효'],
    //     ['SUR', '계약해약'],
    //   ],
    //   status_options: [['All', '-전부-'], ['O', '수속중'], ['C', '완료']],
    //   // policy_status: [
    //   //   ['COD', '완료'],
    //   //   ['CAN', '해지'],
    //   //   ['COF', '청약철회'],
    //   //   ['LAP', '계약실효'],
    //   //   ['SUR', '계약해약'],
    //   //   ['TOT', '전환해약'],
    //   //   ['TER', '종료'],
    //   // ],
    //   exclude_policy_status: [
    //     ['COD', '완료'],
    //     ['CAN', '해지'],
    //     ['COF', '청약철회'],
    //     ['LAP', '계약실효'],
    //     ['SUR', '계약해약'],
    //     ['TOT', '전환해약'],
    //     ['TER', '종료'],
    //   ],
    //   b2b_product_type: [
    //     ['IL', '투자형 보험'],
    //     ['IN', '보험플랜'],
    //     ['FD', '펀드 플랫폼'],
    //     ['GI', '일반보험'],
    //     ['MPF', 'MPF'],
    //     ['PB', 'Private Bank'],
    //     ['TU', 'Trust'],
    //   ],
    // },
    // // change_password: {
    // //   label: '비밀번호 변경',
    // //   description: '* 비밀번호는 6-10자로 설정하실 수 있습니다.',
    // //   current: '현재 비밀번호',
    // //   new: '새 비밀번호',
    // //   confirm_new: '새 비밀번호를 입력하여 주십시오.',
    // //   success_message: '비밀번호가 성공적으로 변경되었습니다.',
    // // },
    // statement: {
    //   total_portfolio_value_alert:
    //     '商品プロバイダーからのデータ提供にて不具合が生じた為、運用報告書が表示できておりません。 ご迷惑をおかけして申し訳ございませんが、問題が解決するまで暫くお時間頂戴できます様お願い致します。',
    // },
    // report: {
    //   reports: '보고서',
    //   product_type: '상품분류',
    //   exclude: '제외',
    //   month: '분류',
    //   type: '분류',
    //   to: '부터',
    //   lapsed_surrender_date: '계약실효 / 해약일 (YYYY/MM/DD)',
    //   transfer_in_effective_date: '전환가입 유효일 (YYYY/MM/DD)',
    //   sr_created_date: '서비스 기록 작성일 (YYYY/MM/DD)',
    //   cc_expiry_date: '신용카드만료일 (YYYY/MM)',
    //   received_date: '수령일 (YYYY/MM/DD)',
    //   date_attened: 'Date Attened (YYYY/MM/DD)',
    //   export: '엑셀화일로 전환',
    // },
  },
};

export default commonKr;
